import axios from 'axios';
import {toast} from "vue3-toastify"; // Import Axios library
import { debounce } from 'lodash';

// On the server-rendered home page, LandingController ships categories/subcategories
// as window.__BOOT__ so the store starts pre-populated (no duplicate API call, no
// loading flash). Falls back to empty arrays on every other (SPA-shell) route.
const boot = (typeof window !== 'undefined' && window.__BOOT__) || {};

const homeModule = {
    namespaced: true,
    state() {
        return {
            category_loading: false,
            categories: boot.categories || [],
            location: {
                city: '',
                country_name: '',
                country_id: '',
                city_id: '',
                all_countries: []
            },
            locationLoading: false,
            changeLocation: {
                country_name: '',
                country_id: '',
            },
            subcategories: boot.subcategories || [],
            paginationCurrentPage: 1,
            paginationTotalPages: 0,
            // claim businesses
            businesses: [],
            // Seeded on the SSR home page via __BOOT__, and on the other server-rendered
            // pages via __BOOT_SETTINGS__ (logo etc. render instantly — no header/footer CLS).
            settings: boot.settings
                || (typeof window !== 'undefined' && window.__BOOT_SETTINGS__)
                || [],
            searchQuery: "",
            selectedBusiness: null,
            businessSelect: true,
            form: {
                name: "",
                email: "",
                phone: "",
                message: "",
                business_id: "",
            },
            errors: {},
            loading: false,
            loader:false,
            reportInfoForm: {
                name: "", email: "", phone: "", message: "", business_id: "",
            },
            reportInfoErrors: {},
            reportInfoLoading: false,
            loadingMorePages: false,
            morePages: [],
        } 
    },

    mutations: {
        SET_CATEGORIES_DATA(state, data) {
            state.categories = data.categories
            state.subcategories = data.subcategories
        },
        SET_CATEGORIES_LOADING(state, loading) {
            state.category_loading = loading;
        },
        SET_LOCATION(state, data) {
            state.location.city = data.city || ''; // Set city if available
            state.location.city_id = data.city_id || '';
            state.location.country_name = data.country_name || ''; // Set country name if available
            state.location.country_id = data.country_id || ''; // Set country name if available
            state.location.all_countries = data.all_countries || []; // Set all countries if available
        },
        SET_LOCATION_LOADING(state, loading) {
            state.locationLoading = loading;
        },
        SET_LOCATION_DATA(state, data) {
            state.location.country_name = data.country_name || ''; // Set country name if available
            state.location.country_id = data.country_id || ''; // Set country name if available
        },
        SET_BUSINESSES_DATA(state, data) {
            state.businesses = Array.isArray(data) ? data : [];
        },
        SET_SELECTED_BUSINESS(state, business) {
            state.selectedBusiness = business;
        },
        SET_SEARCH_QUERY(state, query) {
            state.searchQuery = query;
        },
        SET_BUSINESS_SELECT(state, status) {
            state.businessSelect = status;
        },
        SET_FORM_FIELD(state, { field, value }) {
            state.form[field] = value;
        },
        SET_REPORT_INFO_FORM_FIELD(state, { field, value }) {
            state.reportInfoForm[field] = value;
        },
        SET_REPORT_INFO_ERRORS(state, errors) {
            state.reportInfoErrors = errors;
        },
        SET_REPORT_INFO_LOADING(state, loading) {
            state.reportInfoLoading = loading;
        },
        SET_ERRORS(state, errors) {
            state.errors = errors;
        },
        SET_LOADING(state, status) {
            state.loading = status;
        },
        CLEAR_FORM(state) {
            state.form = {
                name: "",
                email: "",
                phone: "",
                message: "",
                business_id: "",
            };
        },
        CLEAR_ERRORS(state) {
            state.errors = {};
        },
        CHANGE_SEARCH_QUERY(state , value){
            state.searchQuery = value;
        },
        SET_POST_REVIEW_LOADER(state ,value){
            state.loader = value;
        },
        SET_SETTINGS(state, data) {
            state.settings = data;
        },
        SET_MORE_PAGES_LOADING(state, loading) {
            state.loadingMorePages = loading;
        },
        SET_MORE_PAGES(state, data) {
            state.morePages = data;
        },
    },

    actions: {
        async getLocation({commit}, search) {
            try {
                commit('SET_LOCATION_LOADING', true);
                const response = await axios.get('/api/get-location', {
                    params: {search} // Ensure the search parameter is passed correctly
                });
                console.log('Location API response:', response.data); // Log the API response
                commit('SET_LOCATION', response.data);
                localStorage.setItem('country_id', response.data.country_id);
                localStorage.setItem('country_name', response.data.country_name);
            } catch (error) {
                console.error("Error fetching location:", error.response.data.message);
            } finally {
                commit('SET_LOCATION_LOADING', false);
            }
            
        },

        async fetchCategories({commit}) {
            const url = `/api/categories-data`;
            try {
                commit('SET_CATEGORIES_LOADING', true);
                let response = await axios.get(url);
                commit('SET_CATEGORIES_DATA', response.data);
                // console.log("SETCATEGROIESDATA ",response.data)
                commit('SET_CATEGORIES_LOADING', false);
            } catch (errors) {
                console.log(errors);
            }
        },
        async setLocation({commit}, {country_name, country_id}) {
            localStorage.setItem('country_id', country_id);
            localStorage.setItem('country_name', country_name);
            commit('SET_LOCATION_DATA', {country_name, country_id});
            console.log('SET_LOCATION_DATA', {country_name, country_id})
        },

      searchBusiness: debounce(async function({ state, commit }) {
    const query = state.searchQuery.trim();

    if (!query) {
        commit('SET_BUSINESSES_DATA', []);
        return;
    }

    try {
        const response = await axios.get(`/api/claim-businesses`, {
            params: { query }
        });
        commit('SET_BUSINESSES_DATA', response.data.data || response.data);
    } catch (error) {
        toast.error("Error fetching businesses!");
        commit('SET_BUSINESSES_DATA', []);
    }
}, 300),

        //  update form when user click on searched business
        updateFormField({ commit }, payload) {
            commit("SET_FORM_FIELD", payload);
        },
        updateReportInfoFormField({ commit }, payload) {
            commit("SET_REPORT_INFO_FORM_FIELD", payload);
        },
        // storing selected business data and more
        selectBusiness({ commit }, item) {
            commit('SET_SELECTED_BUSINESS', item);
            commit('SET_SEARCH_QUERY', item.business_name);
            commit('SET_BUSINESSES_DATA', []);
            commit('SET_BUSINESS_SELECT', false);
        },


        // storing form data claim businesses
        validateForm({ state, commit }) {
            let errors = {};

            if (!state.form.name.trim()) {
                errors.name = "Name field is required.";
            } else if (state.form.name.length < 3) {
                errors.name = "Name must be at least 3 characters.";
            } else if (state.form.name.length > 255) {
                errors.name = "Name must not be greater than 255 characters.";
            }

            if (!state.form.email.trim()) {
                errors.email = "Email field is required.";
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.form.email)) {
                errors.email = "Enter a valid email address.";
            }


            if (!state.form.phone.trim()) {
                errors.phone = "Phone field is required.";
            } else if (!/^\+?\d{1,3}?[-.\s]?\(?\d{1,4}?\)?[-.\s]?\d{3,4}[-.\s]?\d{4}$/.test(state.form.phone)) {
                errors.phone = "Enter a valid phone number.";
            }


            if (!state.form.message.trim()) {
                errors.message = "Message field is required.";
            }

            commit("SET_ERRORS", errors);
            return Object.keys(errors).length === 0;
        },

        async ClaimBusinessContact({ state, commit, dispatch } ,formData) {
            commit("SET_LOADING", true);

            const isValid = await dispatch("validateForm"); // Await the result
            if (!isValid) {
                commit("SET_LOADING", false);
                return;
            }


            try {
                const url = "/api/claim-business/store";
                const token = localStorage.getItem("token");

                let response = await axios.post(url, formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    commit("CLEAR_FORM");
                    commit("CLEAR_ERRORS");
                }
            } catch (error) {
                // const errorMessage = error.response?.data?.message || "An error occurred.";
                // toast.error(errorMessage);
                // console.error("Error in ClaimBusinessContact:", errorMessage);
            } finally {
                commit("SET_LOADING", false);
            }
        },

    //     post reviews

        async postReviews( {commit},formData) {
                commit("SET_POST_REVIEW_LOADER", true);
            try {
                const url = `/api/business/review`;
                const token = localStorage.getItem('token');

                let response = await axios.post(url, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });

                return response;
            } catch (error) {
                console.error("API Error:", error);
                throw error; // Rethrow to handle it in postReview
            } finally {
                commit("SET_POST_REVIEW_LOADER", false);
            }
        },

        async fetchSettings({commit}) {
            try {
                let response = await axios.get('/api/settings');
                commit('SET_SETTINGS', response.data);
            } catch (error) {
                console.error("API Error:", error);
            }
        },


        async reportIncorrectInfo({ commit }, formData) {
            try {
                commit("SET_REPORT_INFO_LOADING", true);
                commit("SET_REPORT_INFO_ERRORS", {}); // clear previous errors

                const url = "/api/invalid-info-report";
                let response = await axios.post(url, formData);
                console.log(response);
                if (response.data?.status === "success") {
                    toast.success(response.data?.message);
                    commit("SET_REPORT_INFO_ERRORS", {});
                    // clear form if needed
                    commit("SET_REPORT_INFO_FORM_FIELD", { field: "name", value: "" });
                    commit("SET_REPORT_INFO_FORM_FIELD", { field: "email", value: "" });
                    commit("SET_REPORT_INFO_FORM_FIELD", { field: "phone", value: "" });
                    commit("SET_REPORT_INFO_FORM_FIELD", { field: "message", value: "" });
                    commit("SET_REPORT_INFO_FORM_FIELD", { field: "business_id", value: "" });
                }
            } catch (error) {
                // Handle validation errors from Laravel
                if (error.response && error.response.status === 422) {
                    commit("SET_REPORT_INFO_ERRORS", error.response.data.errors);
                } else {
                    toast.error("Something went wrong! Please try again.");
                }
            } finally {
                commit("SET_REPORT_INFO_LOADING", false);
            }
        },

        async fetchMorePages({commit}) {
            try {
                commit('SET_MORE_PAGES_LOADING', true);
                const response = await axios.get('/api/get-more-pages');
                commit('SET_MORE_PAGES', response.data.data);
            } catch (error) {
                console.error("API Error (fetching more pages):", error);
            } finally {
                commit('SET_MORE_PAGES_LOADING', false);
            }
        },

    },

    getters: {
        displayedItems: (state) => {
    return Array.isArray(state.businesses) ? state.businesses : [];
},


    },


};

export default homeModule;
